import React, { useState, useCallback, useEffect } from 'react';
import { createFormField } from 'Shared/utils/createFormField';
import { Collapse } from 'reactstrap';
import { Field } from 'react-final-form';
import RadioInput from 'Shared/components/RadioInput/RadioInput';

import FormShareToChat from '../FormShareToChat';
import FormSelectWorkspace from '../FormSelectWorkspace/FormSelectWorkspace';

type Props = {
  value: boolean;
  workspaceIsGroup: boolean;
  workspaceIsDefined: boolean;
  onlyShowPublicOption: boolean;
  onChange: Function;
  nonTeamSyncWorkspacesWithInitialTeammate;
};

function PublicOrPrivate({
  onChange,
  value,
  workspaceIsGroup,
  workspaceIsDefined,
  onlyShowPublicOption,
  nonTeamSyncWorkspacesWithInitialTeammate,
}: Props) {
  const [expandedShareWithTeamOptions, setExpandedShareWithTeamOptions] = useState(value);

  const handleShareWithTeamClick = useCallback(() => onChange(true), [onChange]);

  const handleKeepPrivateClick = useCallback(() => onChange(false), [onChange]);

  useEffect(() => {
    setExpandedShareWithTeamOptions(value);
  }, [value]);

  if (onlyShowPublicOption) {
    return (
      <div className="ml-4 mb-2 pl-1">
        <Field name="chatOptions.shareToChat" component={FormShareToChat} />
      </div>
    );
  }

  const nonTeamSyncWorkspacesWithInitialTeammateIsOnlyOneOnOne =
    nonTeamSyncWorkspacesWithInitialTeammate.length === 1 && nonTeamSyncWorkspacesWithInitialTeammate[0].isOneOnOne;

  const keepPrivateLabel = () => {
    if (!workspaceIsDefined) {
      if (nonTeamSyncWorkspacesWithInitialTeammateIsOnlyOneOnOne) return 'Keep private between the two of you';
      return 'Keep private between the two of you or in a group';
    }
    return `Keep private ${workspaceIsGroup ? 'in this group' : 'between the two of you'}`;
  };

  return (
    <>
      <RadioInput
        name="shareWithTeam"
        label="Public (visible to everyone in the organization)"
        className="mt-1 mt-sm-0"
        checked={value && value !== null}
        onClick={handleShareWithTeamClick}
      />
      <Collapse isOpen={!!expandedShareWithTeamOptions}>
        <div className="ml-4 mb-2 pl-1">
          <Field name="chatOptions.shareToChat" component={FormShareToChat} />
        </div>
      </Collapse>
      <RadioInput
        name="keepPrivate"
        label={keepPrivateLabel()}
        checked={!value && value !== null}
        onClick={handleKeepPrivateClick}
      />
      {!workspaceIsDefined && !nonTeamSyncWorkspacesWithInitialTeammateIsOnlyOneOnOne && (
        <Collapse isOpen={expandedShareWithTeamOptions === false}>
          <div className="ml-4 mb-2 pl-1">
            <Field
              name="workspaceId"
              component={FormSelectWorkspace}
              nonTeamSyncWorkspacesWithInitialTeammate={nonTeamSyncWorkspacesWithInitialTeammate}
            />
          </div>
        </Collapse>
      )}
    </>
  );
}

export default createFormField(PublicOrPrivate);
